import { getCityLocationList } from "_services/accountsServices/cityLocationService";

import {
  CityDropdownForTrip,
  CommonDatePicker,
  CommonDateRange,
  CrossButton,
  CustomSelect,
} from "components";
import { AddButton } from "components/common/CommonButton";
import { UserContext } from "context";
import { updateEwayBillFilters } from "features/ewayBillFilterServices/ewayBillFilterSlice";
import { updateEwayCheckerFilters } from "features/ewayCheckerFilterServices/ewayCheckerFilterSlice";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import StorageService from "utils/StorageServices";

const EwayBillFilterModal = (props) => {

  let { isOpen, onClose, filter, setFilter, isShow, list, name, setFilterCount = () => { } } = props;
  let { isLr_status = false, isPod_status = false, isEway_bill_status = false, isBill_raise_status = false } = isShow;

  const dispatch = useDispatch();

  const [modalFilter, setModalFilter] = useState({
    search: "",
    branch_id: "",
    start_date: "",
    end_date: "",
    user_id: "",
    vehicle_id: "",
    expense_category_id: "",
    consignor_id: "",
    supplier_id: "",
    driver_id: "",
    from_location: "",
    to_location: "",
    vehicle_ownership: 0,
    trip_status: 0,
    plan_status: 0,
    responses: 0,
    vehicle_status: 0,
    stateCode: "",
    lr_status: { label: "All", value: 0 },
    pod_status: { label: "All", value: 0 },
    eway_bill_status: { label: "All", value: 0 },
  });

  const [fromLocationDetails, setFromLocationDetails] = useState({})
  const [toLocationDetails, setToLocationDetails] = useState({})

  const { cities, masterData, tripFilter, setTRipFilter, states, setPlanFilter, planFilter } = useContext(UserContext);

  const [ownserShipList, setOwnserShipList] = useState([]);
  const [tripStatusList, setTripStatusList] = useState([]);
  const [planStatusList, setPlanStatusList] = useState([]);
  const [bidStatusList, setbidStatusList] = useState([]);
  const [responseList, setresponseList] = useState([]);
  const [vehicleStatusList, setVehicleStatusList] = useState([]);
  const [stateList, setStateList] = useState([])

  const [lrStatus, setLrStatus] = useState([]);
  const [podStatus, setPodStatus] = useState([]);
  const [ewayBillStatus, setEwayBillStatus] = useState([]);

  const [listData, setListData] = useState({
    consignorList: [],
    branchList: [],
    supplierList: [],
    driverList: [],
  });

  useEffect(() => {

    const list = states?.map((i) => {
      return {
        ...i,
        label: i?.name,
        value: i?.isoCode,
      };
    })

    setStateList([{ label: "All", value: 0 }, ...list]);
  }, [states])

  useEffect(() => {
    if (filter) {

      setModalFilter({
        search: filter?.search,
        branch_id: filter?.branch_id,
        start_date: filter?.start_date,
        end_date: filter?.end_date,
        user_id: filter?.user_id,
        expense_category_id: filter?.expense_category_id,
        consignor_id: filter?.consignor_id,
        supplier_id: filter?.supplier_id,
        driver_id: filter?.driver_id,
        from_location: filter?.from_location,
        to_location: filter?.to_location,
        vehicle_ownership: filter?.vehicle_ownership,
        trip_status: filter?.trip_status,
        plan_status: filter?.plan_status,
        bid_status: filter?.bid_status,
        responses: filter?.responses,
        vehicle_id: filter?.vehicle_id,
        offset: filter.offset,
        vehicle_status: filter.vehicle_status,
        stateCode: filter.stateCode,
        lr_status: masterData?.lr_status_list?.filter((i) => i?.id == filter?.lr_status)?.map((i) => {
          return {
            label: i?.name,
            value: i?.id,
          };
        })[0],
        pod_status: masterData?.pod_status_list?.filter((i) => i?.id == filter?.pod_status)?.map((i) => {
          return {
            label: i?.name,
            value: i?.id,
          };
        })[0],
        eway_bill_status: masterData?.eway_bill_status_list?.filter((i) => i?.id == filter?.eway_bill_status)?.map((i) => {
          return {
            label: i?.name,
            value: i?.id,
          };
        })[0],
      });
      getStateFromCity({ fromcity: filter?.from_location, tocity: "" })
      getStateFromCity({ tocity: filter?.to_location, fromcity: "" })

    }
  }, [filter, masterData]);

  useEffect(() => {
    if (masterData) {
      const list = masterData?.vehicle_ownership_list.map((i) => {
        return {
          label: i?.name,
          value: i?.id,
        };
      });

      const tripSList = masterData?.trip_status_list?.map((i) => {
        return {
          label: i?.name,
          value: i?.id,
        };
      });

      const planList = masterData?.plan_status_list?.map((i) => {
        return {
          label: i?.name,
          value: i?.id,
        };
      });
      const bidList = masterData?.bid_status_list?.map((i) => {
        return {
          label: i?.name,
          value: i?.id,
        };
      });
      const respList = masterData?.plan_responses_list?.map((i) => {
        return {
          label: i?.name,
          value: i?.id,
        };
      });

      const vehicleStatusList = masterData?.vehicle_status_list?.map((i) => {
        return {
          label: i?.name,
          value: i?.id,
        };
      });

      const lrStatuslist = masterData?.lr_status_list?.filter((el) => (el?.id != 2 && el?.id != 5 && el?.id != 6 && el?.id != 7))?.map((i) => {
        return {
          label: i?.name,
          value: i?.id,
        };
      });

      const podStatuslist = masterData?.pod_status_list?.map((i) => {
        return {
          label: i?.name,
          value: i?.id,
        };
      });

      const ewayBillStatuslist = masterData?.eway_bill_status_list?.filter((el) => el?.id != 3).map((i) => {
        return {
          label: i?.name,
          value: i?.id,
        };
      });

      setOwnserShipList([{ label: "All", value: 0 }, ...list]);
      setTripStatusList([{ label: "All", value: 0 }, ...tripSList]);
      setPlanStatusList([...planList]);
      setbidStatusList([{ label: "All", value: 0 }, ...bidList]);
      setresponseList([{ label: "All", value: 0 }, ...respList]);
      setVehicleStatusList([{ label: "All", value: 0 }, ...vehicleStatusList]);

      setLrStatus([{ label: "All", value: 0 }, ...lrStatuslist])
      setPodStatus([{ label: "All", value: 0 }, ...podStatuslist])
      setEwayBillStatus([{ label: "All", value: 0 }, ...ewayBillStatuslist])

    }
  }, [masterData]);

  const getStateFromCity = ({ fromcity, tocity }) => {

    const matchedCity = cities.find(c => c.name === fromcity || c.name === tocity);
    const stateCode = matchedCity?.stateCode;

    const matchedState = states.find(s => s.isoCode === stateCode);

    if (matchedState) {
      if (fromcity) {

        setFromLocationDetails({ name: fromcity, label: `${fromcity}, ${matchedState.name}` });
      }

      if (tocity) {
        setToLocationDetails({ name: tocity, label: `${tocity}, ${matchedState.name}` });
      }

    }
  };

  const fetchFromCity = async (search, page, limit) => {
    const res = await getCityLocationList({
      countryCode: "IN",
      stateCode: "",
      offset: page,
      limit,
      search,

    });
    if (res?.responseCode === 200) {
      const list = res?.data?.all_cities.map((c) => ({ ...c, _id: c.name, label: `${c.name}, ${c.stateName}` }))

      return {

        items: [...list],

        total: res?.data?.total_record,
      };

    } else {
      toast.error(res?.responseMessage);
    }
  };

  const handleSave = () => {
    const commonFilter = {
      search: modalFilter?.search,
      branch_id: modalFilter?.branch_id,
      start_date: modalFilter?.start_date,
      end_date: modalFilter?.end_date,
    };

    switch (name) {
      case "plan":
        setFilter({
          ...filter,
          ...commonFilter,
          consignor_id: modalFilter?.consignor_id,
          plan_status: modalFilter?.plan_status,
          from_location: modalFilter?.from_location,
          to_location: modalFilter?.to_location,
          bid_status: modalFilter?.bid_status,
          responses: modalFilter?.responses,
          vehicle_id: modalFilter?.vehicle_id
        });
        setPlanFilter({
          ...planFilter,
          ...commonFilter,
          consignor_id: modalFilter?.consignor_id,
          plan_status: modalFilter?.plan_status,
          from_location: modalFilter?.from_location,
          to_location: modalFilter?.to_location,
          bid_status: modalFilter?.bid_status,
          responses: modalFilter?.responses,
          vehicle_id: modalFilter?.vehicle_id
        });
        break;

      case "Trip":
        setFilter({
          ...filter,
          ...commonFilter,
          consignor_id: modalFilter?.consignor_id,
          supplier_id: modalFilter?.supplier_id,
          driver_id: modalFilter?.driver_id,
          from_location: modalFilter?.from_location,
          to_location: modalFilter?.to_location,
          vehicle_ownership: modalFilter?.vehicle_ownership,
          trip_status: modalFilter?.trip_status,
          vehicle_id: modalFilter?.vehicle_id,
          offset: modalFilter?.offset
        });
        setTRipFilter({
          ...filter,
          ...commonFilter,
          consignor_id: modalFilter?.consignor_id,
          supplier_id: modalFilter?.supplier_id,
          driver_id: modalFilter?.driver_id,
          from_location: modalFilter?.from_location,
          to_location: modalFilter?.to_location,
          vehicle_ownership: modalFilter?.vehicle_ownership,
          trip_status: modalFilter?.trip_status,
          vehicle_id: modalFilter?.vehicle_id,
          offset: modalFilter?.offset
        });
        break;

      case "payment":
        setFilter({
          ...filter,
          ...commonFilter,
          expense_category_id: modalFilter?.expense_category_id,
          param_user_id: modalFilter?.user_id,
          serach: modalFilter?.search,
        });
      case "ewayBill":
        setFilter({
          ...filter,
          search: modalFilter?.search,
          branch_id: modalFilter?.branch_id,
          start_date: modalFilter?.start_date,
          end_date: modalFilter?.end_date,
          consignor_id: modalFilter?.consignor_id,
          from_location: modalFilter?.from_location,
          to_location: modalFilter?.to_location,
          lr_status: modalFilter?.lr_status?.value,
          pod_status: modalFilter?.pod_status?.value,
          eway_bill_status: modalFilter?.eway_bill_status?.value,
          offset: 1
        });
        dispatch(updateEwayBillFilters({
          ...filter,
          search: modalFilter?.search,
          branch_id: modalFilter?.branch_id,
          start_date: modalFilter?.start_date,
          end_date: modalFilter?.end_date,
          consignor_id: modalFilter?.consignor_id,
          from_location: modalFilter?.from_location,
          to_location: modalFilter?.to_location,
          lr_status: modalFilter?.lr_status?.value,
          pod_status: modalFilter?.pod_status?.value,
          eway_bill_status: modalFilter?.eway_bill_status?.value,
          offset: 1
        }))
        break;
      case "ewayChecker":
        setFilter({
          ...filter,
          search: modalFilter?.search,
          branch_id: modalFilter?.branch_id,
          start_date: modalFilter?.start_date,
          end_date: modalFilter?.end_date,
          consignor_id: modalFilter?.consignor_id,
          from_location: modalFilter?.from_location,
          to_location: modalFilter?.to_location,
          lr_status: modalFilter?.lr_status?.value,
          pod_status: modalFilter?.pod_status?.value,
          eway_bill_status: modalFilter?.eway_bill_status?.value,
          offset: 1
        });
        dispatch(updateEwayCheckerFilters({
          ...filter,
          search: modalFilter?.search,
          branch_id: modalFilter?.branch_id,
          start_date: modalFilter?.start_date,
          end_date: modalFilter?.end_date,
          consignor_id: modalFilter?.consignor_id,
          from_location: modalFilter?.from_location,
          to_location: modalFilter?.to_location,
          lr_status: modalFilter?.lr_status?.value,
          pod_status: modalFilter?.pod_status?.value,
          eway_bill_status: modalFilter?.eway_bill_status?.value,
          offset: 1
        }))
        break;

      case "Vehicle":
        setFilter({
          ...filter,
          ...commonFilter,
          vehicle_ownership: modalFilter?.vehicle_ownership,
          vehicle_status: modalFilter?.vehicle_status,
          offset: modalFilter.offset,
        });
        break;

      case "Loaction":
        setFilter({
          ...filter,
          ...commonFilter,
          offset: modalFilter.offset,
          stateCode: modalFilter.stateCode,
        });
        break;
      default:
        console.warn("Unknown filter name:", name);
        break;
    }


    onClose(false);
  };

  const onhandleSelect = async (item, name) => {
    const stateObj = { ...modalFilter, [name]: item };
    setModalFilter(stateObj);
  }

  return (
    <>
      <div className="offcanvas-header">
        <div className="d-flex gap-2 align-items-center">
          <h5 className="offcanvas-title"> {`Filters `} </h5>{" "}
          {filter?.search ? (
            <div className="_counts"> {filter?.search ? 1 : 0} </div>
          ) : (
            <></>
          )}
        </div>
        <CrossButton
          type="button"
          className="_switchBtn  __animEffect_btn"
          onClick={(e) => onClose(false)}
          style={{marginLeft:'auto'}}
        >
          <svg
            className="cross"
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
          >
            <path
              d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
              fill="black"
            />
          </svg>
        </CrossButton>
      </div>

      <div className="offcanvas-body">
        <div className="_tableFilter_inrFx">
          <div className="_leftFilts">
            <div className="_filtrFlx">
              <div className="_inpW_search">
                <svg
                  className="srcIcon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                >
                  <path
                    opacity="0.2"
                    d="M16.5311 15.6665L11.9134 11.0488C13.023 9.71662 13.5764 8.00793 13.4583 6.27818C13.3402 4.54842 12.5598 2.93078 11.2794 1.76176C9.99906 0.592742 8.31727 -0.0376443 6.58394 0.0017403C4.8506 0.0411249 3.19918 0.747248 1.97322 1.97322C0.747248 3.19918 0.0411249 4.8506 0.0017403 6.58394C-0.0376443 8.31727 0.592742 9.99906 1.76176 11.2794C2.93078 12.5598 4.54842 13.3402 6.27818 13.4583C8.00793 13.5764 9.71662 13.023 11.0488 11.9134L15.6665 16.5311L16.5311 15.6665ZM1.24477 6.74783C1.24477 5.65943 1.56752 4.59547 2.1722 3.69049C2.77689 2.78552 3.63635 2.08018 4.6419 1.66366C5.64745 1.24715 6.75394 1.13817 7.82143 1.35051C8.88892 1.56285 9.86947 2.08696 10.6391 2.85658C11.4087 3.6262 11.9328 4.60675 12.1452 5.67424C12.3575 6.74173 12.2485 7.84821 11.832 8.85376C11.4155 9.85932 10.7101 10.7188 9.80517 11.3235C8.9002 11.9281 7.83623 12.2509 6.74783 12.2509C5.28883 12.2493 3.89004 11.669 2.85837 10.6373C1.82669 9.60562 1.24639 8.20684 1.24477 6.74783Z"
                    fill="black"
                  />
                </svg>
                <input
                  type="text"
                  placeholder="Search"
                  className="simpleFilter_input"
                  value={modalFilter.search}
                  onChange={(e) =>
                    setModalFilter((s) => ({
                      ...s,
                      search: e.target.value,
                      offset: 1,
                    }))
                  }
                />
              </div>
            </div>
            {isShow?.datePicker && (
              <div className="singleDiv">
                {" "}
                <CommonDatePicker
                  name="date"
                  label="Date"
                  startDate={modalFilter?.start_date}
                  setStartDate={(data) => {
                    setModalFilter((s) => ({
                      ...s,
                      start_date: data,
                    }));
                  }}

                />
              </div>
            )}
            {isShow?.dateRange && (
              <div className="singleDiv">
                {" "}
                <CommonDateRange

                  initialStartDate={
                    modalFilter?.start_date ? modalFilter?.start_date : ""
                  }
                  initialEndDate={
                    modalFilter?.end_date ? modalFilter?.end_date : ""
                  }
                  onApply={(data) => {
                    setModalFilter({
                      ...modalFilter,
                      start_date: moment(data?.startDate),
                      end_date: moment(data?.endDate),
                    });
                  }}
                  datePrefield={
                    !modalFilter?.start_date && !modalFilter?.end_date
                      ? false
                      : true
                  }
                />
              </div>
            )}

            {isShow?.fromLocation ? (
              <div className="singleDiv">

                <CityDropdownForTrip
                  key={`fromLoction`}
                  label="From Location"
                  placeholder="Select Location"
                  fetchData={fetchFromCity}
                  pageSize={20}
                  onChange={(data) => {
                    setModalFilter((s) => ({
                      ...s,
                      from_location: data?.name,
                      offset: 1,
                    }))
                    setFromLocationDetails(data)
                  }}
                  selectedItem={
                    fromLocationDetails
                  }
                />

              </div>
            ) : <></>}

            {isShow?.toLocation ? (
              <div className="singleDiv">

                <CityDropdownForTrip
                  key={`toLoction`}
                  label="To Location"
                  placeholder="Select Location"
                  fetchData={fetchFromCity}
                  pageSize={20}
                  onChange={(data) => {
                    setModalFilter((s) => ({
                      ...s,
                      to_location: data?.name,
                      offset: 1,
                    }))
                    setToLocationDetails(data)
                  }}
                  selectedItem={
                    toLocationDetails
                  }
                />
              </div>
            ) : <></>}

            {isShow?.allBranch && (
              <div className="singleDiv">
                <CustomSelect
                  label="Branch"
                  placeholder="Select Branch"
                  options={list?.branch ? list?.branch : []}
                  value={list?.branch?.find(
                    (i) => i?.value == modalFilter?.branch_id
                  )}

                  onSelect={(data) => {
                    setModalFilter((s) => ({
                      ...s,
                      branch_id: data?.value,
                      offset: 1,
                    }));
                  }}
                />
              </div>
            )}

            {isShow?.allUser && (
              <div className="singleDiv">
                <CustomSelect
                  label="User"
                  placeholder="All users"
                  options={list?.user}
                  value={list?.user?.find(
                    (i) => i?.value?._id == modalFilter?.user_id
                  )}

                  onSelect={(data) => {
                    setModalFilter((s) => ({
                      ...s,
                      user_id: data?.value?._id,
                      offset: 1,
                    }));
                  }}
                />
              </div>
            )}

            {isShow?.expenseCatagory && (
              <div className="singleDiv">
                <CustomSelect
                  label="Expenses Category"
                  placeholder="All Categories"
                  options={list?.expense}
                  value={list?.expense?.find(
                    (i) => i?.value == modalFilter?.expense_category_id
                  )}

                  onSelect={(data) => {
                    setModalFilter((s) => ({
                      ...s,
                      expense_category_id: data?.value,
                      offset: 1,
                    }));
                  }}
                />
              </div>
            )}

            {isShow?.consignor && (
              <div className="singleDiv">
                <CustomSelect
                  label="Consignor"
                  placeholder="Select Consignor"
                  options={list?.consignor ? list?.consignor : []}
                  value={list?.consignor?.find(
                    (i) => i?.value == modalFilter?.consignor_id
                  )}

                  onSelect={(data) => {
                    setModalFilter((s) => ({
                      ...s,
                      consignor_id: data?.value,
                      offset: 1,
                    }));
                  }}
                />
              </div>
            )}

            {isShow?.supplier && (
              <div className="singleDiv">
                <CustomSelect
                  label="Supplier"
                  placeholder="Select Supplier"
                  options={list?.supplier ? list?.supplier : []}
                  value={list?.supplier?.find(
                    (i) => i?.value == modalFilter?.supplier_id
                  )}

                  onSelect={(data) => {
                    setModalFilter((s) => ({
                      ...s,
                      supplier_id: data?.value,
                      offset: 1,
                    }));
                  }}
                />
              </div>
            )}
            {isShow?.driver && (
              <div className="singleDiv">
                <CustomSelect
                  label="Driver"
                  placeholder="Select Driver"
                  options={list?.driver ? list?.driver : []}
                  value={list?.driver?.find(
                    (i) => i?.value == modalFilter?.driver_id
                  )}

                  onSelect={(data) => {
                    setModalFilter((s) => ({
                      ...s,
                      driver_id: data?.value,
                      offset: 1,
                    }));
                  }}
                />
              </div>
            )}

            {isShow?.ownership && (
              <div className="singleDiv">
                <CustomSelect
                  label="Ownership"
                  placeholder="Select Ownership"
                  options={ownserShipList || []}
                  value={ownserShipList?.find(
                    (i) => i?.value == modalFilter?.vehicle_ownership
                  )}

                  onSelect={(data) => {
                    setModalFilter((s) => ({
                      ...s,
                      vehicle_ownership: data?.value,
                      offset: 1,
                    }));
                  }}
                />
              </div>
            )}

            {isShow?.vehicle && (
              <div className="singleDiv">
                <CustomSelect
                  label="Vehicle"
                  placeholder="Select vehicle"
                  options={list?.vehicle ? list?.vehicle : []}
                  value={list?.vehicle?.find(
                    (i) => i?.value == modalFilter?.vehicle_id
                  )}

                  onSelect={(data) => {
                    setModalFilter((s) => ({
                      ...s,
                      vehicle_id: data?.value,
                      offset: 1,
                    }));
                  }}
                />
              </div>
            )}

            {isShow?.tripStatus && (
              <div className="singleDiv">
                <CustomSelect
                  label="Status"
                  placeholder="Select Status"
                  options={tripStatusList || []}
                  value={tripStatusList?.find(
                    (i) => i?.value == modalFilter?.trip_status
                  )}

                  onSelect={(data) => {
                    setModalFilter((s) => ({
                      ...s,
                      trip_status: data?.value,
                      offset: 1,
                    }));
                  }}
                />
              </div>
            )}
            {isShow?.planStatus && (
              <div className="singleDiv">
                <CustomSelect
                  label="Plan Status"
                  placeholder="Select Status"
                  options={planStatusList || []}
                  value={planStatusList?.find(
                    (i) => i?.value == modalFilter?.plan_status
                  )}
                  onSelect={(data) => {
                    setModalFilter((s) => ({
                      ...s,
                      plan_status: data?.value,
                      bid_status: data?.value == 1 ? 0 : s.bid_status,
                      responses: data?.value == 1 ? 0 : s.responses,
                      offset: 1,
                    }));
                  }}
                />
              </div>
            )}

            {isShow?.bidStatus && modalFilter?.plan_status == 1 && (
              <div className="singleDiv">
                <CustomSelect
                  label="Bid Status"
                  placeholder="Select Status"
                  options={bidStatusList || []}
                  value={bidStatusList?.find(
                    (i) => i?.value == modalFilter?.bid_status
                  )}
                  onSelect={(data) => {
                    setModalFilter((s) => ({
                      ...s,
                      bid_status: data?.value,
                      offset: 1,
                    }));
                  }}
                />
              </div>
            )}
            {isShow?.responses && modalFilter?.plan_status == 1 && (
              <div className="singleDiv">
                <CustomSelect
                  label="Responses"
                  placeholder="Select Status"
                  options={responseList || []}
                  value={responseList?.find(
                    (i) => i?.value == modalFilter?.responses
                  )}
                  onSelect={(data) => {
                    setModalFilter((s) => ({
                      ...s,
                      responses: data?.value,
                      offset: 1,
                    }));
                  }}
                />
              </div>
            )}
            {isShow?.vehicle_status && (
              <div className="singleDiv">
                <CustomSelect
                  label="Status"
                  placeholder="Select Status"
                  options={vehicleStatusList || []}
                  value={vehicleStatusList?.find(
                    (i) => i?.value == modalFilter?.vehicle_status
                  )}

                  onSelect={(data) => {
                    setModalFilter((s) => ({
                      ...s,
                      vehicle_status: data?.value,
                      offset: 1,
                    }));
                  }}
                />
              </div>
            )}

            {isShow?.state && (
              <div className="singleDiv">
                <CustomSelect
                  label="State"
                  placeholder="Select States"
                  options={stateList || []}
                  value={stateList?.find(
                    (i) => i?.value == modalFilter?.stateCode
                  )}

                  onSelect={(data) => {
                    setModalFilter((s) => ({
                      ...s,
                      stateCode: data?.value,
                      offset: 1,
                    }));
                  }}
                />
              </div>
            )}

            {isEway_bill_status && (
              <div className="singleDiv">
                <CustomSelect
                  label="Eway Bill Status"
                  placeholder="Eway Bill Status"
                  name="eway_bill_status"
                  options={ewayBillStatus || []}
                  value={modalFilter?.eway_bill_status}
                  onSelect={(data) => onhandleSelect(data, "eway_bill_status")}
                />
              </div>
            )}

            {isPod_status && (
              <div className="singleDiv">
                <CustomSelect
                  label="POD Status"
                  placeholder="POD Status"
                  name="pod_status"
                  options={podStatus || []}
                  value={modalFilter?.pod_status}
                  onSelect={(data) => onhandleSelect(data, "pod_status")}
                />
              </div>
            )}

            {isLr_status && (
              <div className="singleDiv">
                <CustomSelect
                  label="Lr Status"
                  placeholder="Select Status"
                  name="lr_status"
                  options={lrStatus || []}
                  value={modalFilter?.lr_status}
                  onSelect={(data) => onhandleSelect(data, "lr_status")}
                />
              </div>
            )}

          </div>


        </div>
      </div>

      <div className="offcanvas-footer">
        <AddButton
          name="Save"
          className="_addComm_btn"
          onClick={handleSave}
          buttonTitle="Save"
        />

        <button
          className="_cancel_btn"
          onClick={(e) => {
            setFromLocationDetails({ name: "", label: "" });
            setToLocationDetails({ name: "", label: "" });

            setModalFilter((s) => ({
              ...s,
              search: "",
              branch_id: "",
              start_date: "",
              end_date: "",
              user_id: "",
              expense_category_id: "",
              consignor_id: "",
              supplier_id: "",
              driver_id: "",
              from_location: "",
              to_location: "",
              vehicle_ownership: 0,
              trip_status: 0,
              plan_status: 1,
              bid_status: 0,
              responses: 0,
              offset: 1,
              vehicle_id: "",
              vehicle_status: 0,
              stateCode: "",
              // lr_status: 0,
              // pod_status: 0,
              // eway_bill_status: 0,
              lr_status: { label: "All", value: 0 },
              pod_status: { label: "All", value: 0 },
              eway_bill_status: { label: "All", value: 0 },
              offset: 1
            }));
            if (name === 'ewayBill') {
              dispatch(updateEwayBillFilters({
                search: "",
                branch_id: "",
                consignor_id: "",
                start_date: "",
                end_date: "",
                from_location: "",
                to_location: "",
                lr_status: 0,
                pod_status: 0,
                eway_bill_status: 0,
                offset: 1
              }))
            }
            if (name === 'ewayChecker') {
              dispatch(updateEwayCheckerFilters({
                search: "",
                branch_id: "",
                consignor_id: "",
                start_date: "",
                end_date: "",
                from_location: "",
                to_location: "",
                lr_status: 0,
                pod_status: 0,
                eway_bill_status: 0,
                offset: 1
              }))
            }
            if (name == "Trip") {
              setTRipFilter({
                company_id: StorageService.getCompanyId(),
                consignor_id: "",
                supplier_id: "",
                driver_id: "",
                vehicle_ownership: 0,
                from_location: "",
                to_location: "",
                branch_id: "",
                start_date: "",
                end_date: "",
                limit: 25,
                offset: 1,
                search: "",
                trip_status: 0,

                vehicle_id: ""
              });

            }
            if (name == "plan") {
              setPlanFilter({
                company_id: StorageService.getCompanyId(),
                consignor_id: "",
                plan_status: 1,
                from_location: "",
                to_location: "",
                branch_id: "",
                start_date: "",
                end_date: "",
                limit: 25,
                offset: 1,
                search: "",
                bid_status: 0,
                responses: 0,
                vehicle_id: ""
              });

            }
          }}
        >
          Reset
        </button>
      </div>
    </>
  );
};

export default React.memo(EwayBillFilterModal);